import { INITIAL_PAGE } from "../../module_auth/AuthService"

export function PaginationUrl(props) {
    function getNextHref(props) {
        let nextPage = parseInt(props.page) + 1
        if(nextPage > props.lastPage){
            nextPage = props.lastPage
        }
        //let result = INITIAL_PAGE + 'job_list?page=' + nextPage + "&next=true";
        let result = INITIAL_PAGE + props.url + '?page=' + nextPage + "&next=true";
        return result
    }

    function getPreviousHref(props) {
        let previousPage = parseInt(props.page) - 1
        if(previousPage < 1){
            previousPage = 1
        }
        //let result = INITIAL_PAGE + 'job_list?page=' + previousPage + "&previous=true";
        let result = INITIAL_PAGE + props.url + '?page=' + previousPage + "&previous=true";
        return result
    }
    return (
        <div>
            <div class="container d-flex d-sm-flex justify-content-center align-items-center justify-content-sm-center align-items-sm-center" style={{ marginTop: '15px' }}>
                <nav>
                    <ul class="pagination">
                        <li class="page-item"><a class="page-link" aria-label="Previous" href={getPreviousHref(props)}><span aria-hidden="true">«</span></a></li>

                        {/* {PaginationBody(props.pageList, props.activePageIndex)} */}
                        {PaginationBody(props)}

                        <li class="page-item"><a class="page-link" aria-label="Next" href={getNextHref(props)}><span aria-hidden="true">»</span></a></li>
                    </ul>
                </nav>
            </div>
        </div>
    );
}

export function PaginationBody(props) {
    function getHref(page) {
        let result = INITIAL_PAGE + props.url + '?page=' + page
        return result
    }

    return (
        props.pageList.map((page, index) => (
            <li key={index} class={parseInt(props.activePageIndex) === index ? "page-item active" : "page-item"}>
                <a class="page-link" href={getHref(page)}>{page}</a>
            </li>
        ))
    );
}